/* One scroll sample per frame; all feature reads precede feature writes. */
(function () {
  'use strict';
  var jobs = new Map();
  var frame = 0;
  var listening = false;
  var geometryVersion = 0;
  var previousY = window.scrollY || 0;
  function schedule() {
    if (jobs.size && !frame) frame = requestAnimationFrame(flush);
  }
  function refresh() { geometryVersion++; schedule(); }
  function flush() {
    frame = 0;
    var state = {
      y: window.scrollY || document.documentElement.scrollTop || 0,
      previousY: previousY,
      height: window.innerHeight,
      width: window.innerWidth,
      geometryVersion: geometryVersion
    };
    var writes = [];
    jobs.forEach(function (read) {
      var write = read(state);
      if (typeof write === 'function') writes.push(write);
    });
    previousY = state.y;
    writes.forEach(function (write) { write(); });
  }
  function mediaLoad(event) {
    if (event.target && /^(IMG|VIDEO|IFRAME)$/.test(event.target.tagName)) refresh();
  }
  function listen() {
    if (listening) return;
    listening = true;
    previousY = window.scrollY || 0;
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('load', refresh);
    document.addEventListener('load', mediaLoad, true);
    document.addEventListener('loadedmetadata', mediaLoad, true);
  }
  function stopIfEmpty() {
    if (jobs.size || !listening) return;
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', refresh);
    window.removeEventListener('load', refresh);
    document.removeEventListener('load', mediaLoad, true);
    document.removeEventListener('loadedmetadata', mediaLoad, true);
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    listening = false;
  }
  window.novScrollFrame = {
    register: function (key, read) {
      jobs.set(key, read);
      listen();
      schedule();
    },
    remove: function (key) { jobs.delete(key); stopIfEmpty(); },
    refresh: refresh
  };
})();
